import React from 'react';
import PropTypes from "prop-types";

const BookingDetailsLinkedVisitInfo = (props) => {

    const visitors = props.booking.visitors ?? [];

    return (<>
        <div style={{margin: "0.1rem 0"}}>
            {(Object.keys(visitors).map(key => (
                <div key={key} style={{marginTop: "0.1rem"}}>
                    {(props.booking.can_view_linked_visit)
                        ?
                            <a href="/visitors/index/upcoming" target="_blank">
                                {visitors[key].name}
                            </a>
                        :
                            <span>{visitors[key].name}</span>
                    }
                    {(visitors[key].company) && (
                        <span>&nbsp;({visitors[key].company})</span>
                    )}
                </div>
            )))}
        </div>
    </>);
}

BookingDetailsLinkedVisitInfo.propTypes = {
    booking: PropTypes.object,
}

BookingDetailsLinkedVisitInfo.defaultProps = {
    
}

export default BookingDetailsLinkedVisitInfo;
